import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'ngx-loading',
  templateUrl: './global-loader.component.html',
  styleUrls: ['./global-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GlobalLoaderComponent implements OnChanges {
  @Input() set show(value: boolean | string | null | undefined) {
    this.visible = value === true || value === 'true';
    this.cdr.detectChanges();
  }

  @Input() fullScreen: boolean | string = true;

  visible = false;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['show']) {
      const value = changes['show'].currentValue;
      this.visible = value === true || value === 'true';
      this.cdr.detectChanges();
    }
  }
}
